import * as ReactDOM from 'react-dom';

import { LoginPage } from '@ReactComponents/Login/LoginPage';
import { WindowErrors, emburseLoginEnabled, getCompanyIdFromUrl } from '@ReactComponents/Login/loginHelper';

import { AbacusEmbarkProvider } from '@Shared/AbacusEmbarkProvider';

import '../utils/castle';

interface LoginWrapperWindow extends Window {
  csrf: string;
  errors: WindowErrors;
  pkce_challenge: string;
  pkce_state: string;
  pkce_nonce: string;
  whitelabelConfiguration: any;
  webpack_public_path: string;
}

declare const window: LoginWrapperWindow;
declare let __webpack_public_path__: string;

function redirectToAccounts() {
  // wc.account_url references ${config.oidc.baseUrl}/oauth/token suburl
  // wc.account_client_id reference config.oidc.clientId
  const wc = window.whitelabelConfiguration;

  const params = new URLSearchParams({
    response_type: 'code',
    response_mode: 'query',
    client_id: wc.account_client_id,
    redirect_uri: `${wc.host}/login/oidc/assertion`,
    scope: 'openid email licenses',
    nonce: window.pkce_nonce,
    state: window.pkce_state,
    code_challenge: window.pkce_challenge,
    code_challenge_method: 'S256'
  });

  const companyId = getCompanyIdFromUrl(window.location?.search);

  if (companyId) {
    params.set('bu_customer_id', companyId);
  }

  const href = `${wc.account_url}oidc/authorize?${params.toString()}`;

  window.location.href = href;
}

// reset sidebar expanded menu states
sessionStorage.removeItem('expandedMenuIds');

if (window.FEATURES?.emburse_login && emburseLoginEnabled(window.location?.search)) {
  redirectToAccounts();
}

// Set the public path for webpacked assets
// https://webpack.js.org/guides/public-path/
__webpack_public_path__ = window.webpack_public_path;
ReactDOM.render(
  <AbacusEmbarkProvider>
    <LoginPage csrf={window.csrf} locals={window.errors} />
  </AbacusEmbarkProvider>,
  document.querySelector('#app')
);
